











import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator'

@Component
export default class MenuTabs extends Vue {
  activeCls (item: any) {
    const active = this.current === item
    return active ? this.$style.active : ''
  }

  get current () {
    return this.$rp.current
  }

  get items () {
    return this.$rp.items
  }

  resolveShortTitle (title = '') {
    const idx = title.lastIndexOf('/')
    return idx < 0 ? title : title.substr(idx + 1)
  }

  onSelect (row: any) {
    this.$rp.select(row)
  }

  onClose (row: any) {
    this.$rp.close(row)
  }

  $style!: any
}
